const state = {
  memDetail: (() => {
    try {
      return JSON.parse(localStorage.getItem('MEM_INFO')) || {};
    } catch (e) {
      return {};
    }
  })(),
  tabInfo: (() => {
    try {
      const value = sessionStorage.getItem('TAB_INFO');
      return value ? JSON.parse(value) : 'underwritingStatus';
    } catch (e) {
      return 'underwritingStatus';
    }
  })(),
  detailType: (() => {
    try {
      const value = sessionStorage.getItem('DETAIL_TYPE');
      return value ? JSON.parse(value) : '1';
    } catch (e) {
      return '1';
    }
  })(),
  activeSubTab: (() => {
    try {
      const value = sessionStorage.getItem('SUB_TAB');
      return value ? JSON.parse(value) : '1';
    } catch (e) {
      return '1';
    }
  })()
};
const getters = {
  memDetail: state => state.memDetail,
  tabInfo: state => state.tabInfo,
  detailType: state =>state.detailType,
  activeSubTab: state =>state.activeSubTab
};

const mutations = {
  setDeatail(state, data) {
    state.memDetail = data;
    localStorage.setItem('MEM_INFO', JSON.stringify(data));
  },
  setDetailType(state, data) {
    state.detailType = data;
    sessionStorage.setItem('DETAIL_TYPE', JSON.stringify(data));
  },
  setActiveSubTab(state, data) {
    state.activeSubTab = data;
    sessionStorage.setItem('SUB_TAB', JSON.stringify(data));
  },
  setTabInfo(state, data) {
    state.tabInfo = data;
    sessionStorage.setItem('TAB_INFO', JSON.stringify(data));
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  getters
};
